export default {
	SILVER: '1',
	GOLD: '2',
	CART: '4',
	GOLD_PLUS: '6',
	SCHOOL: '3',
	DISTRICT: '5',
	PLATINUM: '7',
}
